import { Product } from '../types';

export interface LocalizedCopy {
  title: string;
  description: string;
}

/**
 * Resolve a product's title + description for the active UI locale.
 *
 * Chain: the requested locale's translation → the canonical source columns
 * → (per field) the source value when a translation field is blank. The
 * source columns (product.title / product.description) hold the
 * `sourceLocale` copy, so a missing or partial translation never renders
 * blank.
 *
 * Note `i18next` language can be a region tag like "en-US" or "fr-FR" — we
 * match on the base subtag so "fr-FR" still resolves the "fr" translation.
 */
export function resolveLocalized(product: Product, locale: string): LocalizedCopy {
  const base = (locale || '').split('-')[0].toLowerCase();
  const source = (product.sourceLocale ?? 'fr').toLowerCase();

  if (base === source) {
    return { title: product.title, description: product.description };
  }

  const t = product.translations?.[base];
  const title = t?.title && t.title.trim() ? t.title : product.title;
  const description =
    t?.description && t.description.trim() ? t.description : product.description;
  return { title, description };
}
